<template lang="pug">
  game-preview-settings
    game-preview-setting
      span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}
      span(slot="value") {{ $i18n.t('trainer')[parameters.mode] }}
    game-preview-setting(v-if="!onlyMultOrDivChosen")
      span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_difficulty') }}
      span(slot="value")
        | {{ $i18n.t('common')[parameters.difficult] + (parameters.combining ? ' (' + $i18n.t('trainer.trainer_gameFormSettingValue_combination') + ')' : '') }}
    template(v-else)
      game-preview-setting(v-if="!onlyDivChosen")
          span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier') }}
          span(slot="value")
              | {{ digitCapacityNames[MultDivLeftHighestCapacity] + (isMultDivLeftCombiningEnabled ? ' (' + $i18n.t('trainer.trainer_gameFormSettingValue_combination') + ')' : '') }}
      game-preview-setting
          span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_dividerMultiplier') }}
          span(slot="value")
              | {{ digitCapacityNames[MultDivRightHighestCapacity] + (isMultDivRightCombiningEnabled ? ' (' + $i18n.t('trainer.trainer_gameFormSettingValue_combination') + ')' : '') }}
    game-preview-setting
      span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfNumbers') }}
      span(slot="value") {{ parameters.numberAmount }}
    game-preview-setting
      span(slot="name") {{ $i18n.t('trainer.trainer_gameSetting_pairsOfBrackets')}}
      span(slot="value") {{ abbreviatedValueOfSetting(parameters.bracketsEnabled) }}
    game-preview-setting(v-if="parameters.bracketsEnabled")
      span(slot="name") {{ $i18n.t('trainer.trainer_gameSetting_amountOfBracketPairs') }}
      span(slot="value") {{ parameters.bracketAmount }}
    game-preview-setting
      span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_operations') }}
      span(slot="value") {{ rulesArrayToString(chosenOperations) }}
    game-preview-setting(v-if="parameters.amountOfExamples")
      span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_examples') }}
      span(slot="value") {{ parameters.amountOfExamples }}
    game-preview-setting
      span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_answers') }}
      span(slot="value") {{ answers }}
    template(v-if="parameters.fractions")
      game-preview-setting
        span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}
        span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
      game-preview-setting
        span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numbersAfterPoints') }}
        span(slot="value") {{ parameters.fractionalPart }}
</template>

<script>
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import GamePreviewSettings from './GamePreviewSettings.vue';
    import GamePreviewSetting from './GamePreviewSetting.vue';
    import preview from '../../../utils/expressions/preview';

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [TrainerUtilities, preview],
        components: {
            GamePreviewSettings,
            GamePreviewSetting,
        },
        computed: {
            amountOfComplicationExercises() {
                return (
                    this.parameters.tasksForComplication +
                    ' ' +
                    this.$i18n.tc(
                        'trainer.trainer_gamePreview_exampleDeclination',
                        this.parameters.tasksForComplication
                    )
                );
            },
            amountOfSpeedExercises() {
                return (
                    this.parameters.tasksForSpeedUp +
                    ' ' +
                    this.$i18n.tc('trainer.trainer_gamePreview_exampleDeclination', this.parameters.tasksForSpeedUp)
                );
            },
            amountOfActions() {
                return (
                    this.parameters.complication +
                    ' ' +
                    this.$i18n.tc('trainer.trainer_gamePreview_actionDeclination', this.parameters.complication)
                );
            },
            timeLimit() {
                return (
                    this.parameters.timeLimit +
                    ' ' +
                    this.$i18n.tc('trainer.trainer_gamePreview_timeParamMinuteDeclination', this.parameters.timeLimit)
                );
            },
            answers() {
                if (this.parameters.positiveAnswers && this.parameters.negativeAnswers) {
                    return this.$i18n.t('trainer.trainer_gameFormSetting_answersAny');
                }
                if (this.parameters.positiveAnswers) {
                    return this.$i18n.t('trainer.trainer_gameFormSetting_answersOnlyPositive');
                }
                if (this.parameters.negativeAnswers) {
                    return this.$i18n.t('trainer.trainer_gameFormSetting_answersOnlyNegative');
                }
                return '';
            },
            chosenOperations() {
                let operations = [];
                if (this.parameters.operations.add) {
                    operations.push('+');
                }
                if (this.parameters.operations.subtract) {
                    operations.push('-');
                }
                if (this.parameters.operations.multiply) {
                    operations.push('×');
                }
                if (this.parameters.operations.divide) {
                    operations.push('÷');
                }
                return operations;
            },
        },
    };
</script>
